import { SearchRounded } from "@mui/icons-material"
import { Button } from "@mui/material/index"

const CBSearchButton = () => {

    return (
        <Button 
            type="submit" 
            size="icon" 
            color={"accent"}
        >
            <SearchRounded/>
        </Button>
    )
}

export default CBSearchButton;